export default __webpack_public_path__ + "static/media/mount.ddd51c00.jpg";